import { render } from "./partA.vue?vue&type=template&id=6a8da48c"
import script from "./partA.vue?vue&type=script&lang=js"
export * from "./partA.vue?vue&type=script&lang=js"

import "./partA.vue?vue&type=style&index=0&id=6a8da48c&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__